import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { showErrorAlert, showSuccessAlert } from '../../../shared/components/alerts/alert.decorator';
import { LoaderEnabled } from '../../services/loader.service';
import { IFeedbackForm } from './help.types';

@Injectable({
  providedIn: 'root',
})
export class HelpApiService {
  constructor(private httpClient: HttpClient) {}

  @showErrorAlert()
  @LoaderEnabled()
  fetchHelpText(): Observable<string> {
    return this.httpClient.get('/api/help', {
      responseType: 'text',
    });
  }

  @showSuccessAlert({
    message: 'help.notification.text.success',
    title: 'help.notification.title.success',
  })
  @showErrorAlert({
    message: 'help.notification.text.danger',
    title: 'help.notification.title.danger',
  })
  @LoaderEnabled()
  sendFeedback(data: IFeedbackForm): Observable<null> {
    const formattedData = {
      subject: `${data.subject} from [${data.email}]`, text: data.text,
    };
    return this.httpClient.post<null>('/api/taxpayer/feedback', formattedData);
  }
}
